function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classNames from 'classnames';
import React, { memo, useState } from 'react';
import FooterMedia from "./components/FooterMedia";
import FooterMenu, { FooterItem } from "./components/FooterMenu";
import "./index.less";
var Footer = /*#__PURE__*/memo(function (props) {
  var className = props.className,
    style = props.style,
    copyright = props.copyright,
    _props$footerData = props.footerData,
    footerData = _props$footerData === void 0 ? [] : _props$footerData,
    _props$mediaData = props.mediaData,
    mediaData = _props$mediaData === void 0 ? [] : _props$mediaData,
    _props$mobileStoreDat = props.mobileStoreData,
    mobileStoreData = _props$mobileStoreDat === void 0 ? [] : _props$mobileStoreDat;
  var classes = classNames('iron-footer', className);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    activeKey = _useState2[0],
    setActiveKey = _useState2[1];
  var handleActive = function handleActive(activeKey) {
    console.log(activeKey);
    setActiveKey(activeKey);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-footer-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "iron-footer-menu-content"
  }, footerData && footerData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(FooterMenu, {
      key: index,
      visible: activeKey === item.value,
      item: item,
      getActiveKey: handleActive
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "iron-footer-copyright"
  }, /*#__PURE__*/React.createElement("div", null, copyright), /*#__PURE__*/React.createElement(FooterMedia, {
    data: mediaData
  }), /*#__PURE__*/React.createElement("ul", {
    className: "iron-footer-copyright-store"
  }, mobileStoreData && mobileStoreData.map(function (subItem, index) {
    return /*#__PURE__*/React.createElement(FooterItem, _extends({
      key: index
    }, subItem));
  })))));
});
export default Footer;